import { programIsFullyWatchable, programIsLive, programIsVod } from '../utils/epg';
import type { EpgChannel, EpgProgram, EpgProgramNavigation } from '../../types/epg';
import type { PlaylistItem } from '../../types/playlist';

export default abstract class EpgService {
  abstract epgDays: number;

  abstract fetchPrograms: (channels: PlaylistItem[], startTime?: number, endTime?: number) => Promise<EpgProgram[]>;

  fetchChannels = async (items: PlaylistItem[], _startTime?: number, _endTime?: number) => {
    return items.map((item) => {
      const catchupHours = item.catchupHours && parseInt(item.catchupHours);

      return {
        id: item.mediaid,
        demo: !!item.scheduleDemo || false,
        title: item.title,
        description: item.description,
        catchupHours: catchupHours ?? 8,
        channelLogoImage: item.channelLogoImage,
        backgroundImage: item.backgroundImage,
        programs: [],
      } as EpgChannel;
    });
  };

  getProgramNavigation = (program: EpgProgram, channel: EpgChannel): EpgProgramNavigation | undefined => {
    if (programIsLive(program)) {
      return { type: 'player' };
    }

    if (programIsVod(program) && programIsFullyWatchable(program, channel.catchupHours)) {
      return { type: 'player', startAt: program.startTime, endAt: program.endTime };
    }

    return undefined;
  };
}
